'use strict';

$(document).ready(function () {
    var $sliderWrapper = $('.image-with-text-carousel');
    var $slider = $sliderWrapper.find('.image-with-text-slides');

    $slider.each(function () {
        var $this = $(this);
        var $carouselContainer = $this.closest('.carousel-container');
        var autoScroll = $carouselContainer.data('autoplay') === true;
        var delayTimer = parseInt($carouselContainer.data('autoplay-speed'), 10);
        var settings = {
            infinite: false,
            autoplay: autoScroll,
            autoplaySpeed: delayTimer > 0 ? delayTimer : 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            prevArrow: $this.siblings('.arrows').find('.prev'),
            nextArrow: $this.siblings('.arrows').find('.next')
        };

        $this.slick(settings);
        $sliderWrapper.removeClass('d-none');
    });
});

var QUICK_PAY_AFTER_LOGIN = 'openQuickPayAfterLogin';
var quickPayInProgress = false;

/**
 * @returns {boolean} true when the shopper is logged in
 */
function isQuickPayCustomerLoggedIn() {
    return $('#customer-authenticated').val() === 'true' || $('.isLoggedInUser').first().val() === 'true';
}

/**
 * Opens the site login popup and resumes Quick Pay once the shopper has logged in
 */
function openQuickPayLogin() {
    try {
        sessionStorage.setItem(QUICK_PAY_AFTER_LOGIN, 'true');
    } catch (e) {
        // storage unavailable: the shopper clicks Quick Pay again after login
    }
    $('#loginPopupModal').data('quickPayInitiator', true).modal('show');
}

/**
 * Loads the logged in customer's payable schemes into the Quick Pay modal
 * @param {jQuery} $button Quick Pay button
 */
function loadQuickPaySchemes($button) {
    if (quickPayInProgress) {
        return;
    }
    quickPayInProgress = true;
    $button.prop('disabled', true);
    $.spinner().start();
    $.ajax({
        url: $button.data('url'),
        type: 'GET',
        success: function (response) {
            // An expired session is redirected to the home page instead of returning the modal
            if (typeof response !== 'string' || response.indexOf('quickPaySchemeModal') === -1) {
                openQuickPayLogin();
                return;
            }
            $('#quickPaySchemeModal').remove();
            $('body').append(response);
            $('#quickPaySchemeModal').modal('show');
        },
        error: function () {
            $('body').trigger('failureToast', 'Unable to fetch your saving schemes. Please try again.');
        },
        complete: function () {
            quickPayInProgress = false;
            $button.prop('disabled', false);
            $.spinner().stop();
        }
    });
}

$(document).on('click', '.quick-pay-login-cta', function (e) {
    e.preventDefault();
    if (isQuickPayCustomerLoggedIn()) {
        loadQuickPaySchemes($(this));
    } else {
        openQuickPayLogin();
    }
});

// Closing the login popup without logging in cancels the pending Quick Pay
$(document).on('hidden.bs.modal', '#loginPopupModal', function () {
    if ($(this).data('quickPayInitiator')) {
        try {
            sessionStorage.removeItem(QUICK_PAY_AFTER_LOGIN);
        } catch (e) {
            // ignore
        }
        $(this).removeData('quickPayInitiator');
    }
});

// The login popup reloads the page after a successful login; continue Quick Pay from there
$(document).ready(function () {
    var resume = false;
    try {
        resume = sessionStorage.getItem(QUICK_PAY_AFTER_LOGIN) === 'true';
        if (resume) {
            sessionStorage.removeItem(QUICK_PAY_AFTER_LOGIN);
        }
    } catch (e) {
        resume = false;
    }
    var $button = $('.quick-pay-login-cta').first();
    if (resume && $button.length && isQuickPayCustomerLoggedIn()) {
        loadQuickPaySchemes($button);
    }
});
